export const getRelevantPremiumErrorMessage = (premiumError) => {
  if (!premiumError)
    return "Premium calculation could not be completed for the selected options.";
  if (typeof premiumError === "string" && premiumError.trim())
    return premiumError.trim();
  if (
    typeof premiumError?.message === "string" &&
    premiumError.message.trim()
  ) {
    return premiumError.message.trim();
  }
  return "Premium calculation could not be completed for the selected options.";
};
